type GenerateFileNameParams = {
   email: string;
   id?: string;
   extension: string;
   label?: string;
};

export const generateFileName = ({
   email,
   id,
   extension,
   label,
}: GenerateFileNameParams) => {
   let filename = '';

   const now = new Date();
   const date =
      now.getUTCDate() +
      '-' +
      (now.getUTCMonth() + 1) +
      '-' +
      now.getUTCFullYear() +
      '-' +
      now.getUTCHours() +
      '-' +
      now.getUTCMinutes();

   label = label
      ?.replaceAll('à', 'a')
      ?.replaceAll('â', 'a')
      ?.replaceAll('Â', 'A')
      ?.replaceAll('À', 'A')
      ?.replaceAll('é', 'e')
      ?.replaceAll('è', 'e')
      ?.replaceAll('ê', 'e')
      ?.replaceAll('ë', 'e')
      ?.replaceAll('É', 'E')
      ?.replaceAll('Ë', 'E')
      ?.replaceAll('Ê', 'E')
      ?.replaceAll('È', 'E')
      ?.replaceAll('ï', 'i')
      ?.replaceAll('î', 'i')
      ?.replaceAll('Î', 'I')
      ?.replaceAll('Ï', 'I')
      ?.replaceAll('ò', 'o')
      ?.replaceAll('ô', 'o')
      ?.replaceAll('ö', 'o')
      ?.replaceAll('Ô', 'O')
      ?.replaceAll('Ö', 'O')
      ?.replaceAll('ù', 'u')
      ?.replaceAll('ü', 'u')
      ?.replaceAll('û', 'u')
      ?.replaceAll('Ù', 'U')
      ?.replaceAll('Ü', 'U')
      ?.replaceAll('Û', 'U')
      ?.replaceAll('ç', 'c')
      ?.replaceAll('Ç', 'C');

   if (email) {
      filename = `${email.replaceAll('.', '_')}_${id}_${extension}`;
   } else if (label) {
      filename = `Q_${label}_${date}${extension}`;
   } else {
      filename = `Q_${date}${extension}`;
   }
   return filename;
};

export const renderFileSize = (size?: number): string => {
   if (!size) return '0 Kb';

   const isLargerThan1MB = Math.round(size / 100) / 10 > 1000;

   return isLargerThan1MB
      ? `${(Math.round(size / 100) / 10000).toFixed(1)} Mb`
      : `${(Math.round(size / 100) / 10).toFixed(1)} Kb`;
};
